import { useState } from "react";
import { toast } from "sonner";
import { Archive, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { apiError } from "../lib/auth";

export const EvidencePackButton = ({ disputeId, txId, label = "Download evidence pack", testid = "evidence-pack-btn", small = false }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await api.get(disputeId ? `/disputes/${disputeId}/evidence-zip` : `/transactions/${txId}/evidence-zip`, { responseType: "blob", timeout: 120000 });
      const name = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || "evidence-pack.zip";
      const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(r.data), download: name });
      a.click();
      const n = Number(r.headers["x-video-count"] || 0);
      toast.success(n ? `Evidence pack downloaded: ${n} video${n > 1 ? "s" : ""} + PDF report, ready for Whop or your bank` : "Evidence pack downloaded: PDF report only. No buyer video was recorded for this payment");
    } catch (e) {
      let msg = apiError(e);
      try { if (e.response?.data instanceof Blob) msg = JSON.parse(await e.response.data.text()).detail || msg; } catch (_) { /* keep generic message */ }
      toast.error(msg);
    } finally { setBusy(false); }
  };
  return (
    <button onClick={go} disabled={busy} data-testid={testid}
      className={small ? "inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-brand hover:underline disabled:opacity-50"
        : "inline-flex items-center gap-2 px-4 py-2 border border-brand text-brand font-mono text-xs uppercase tracking-wider hover:bg-brand/10 transition-colors disabled:opacity-50"}>
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Archive className="w-3.5 h-3.5" />}{busy ? "building pack…" : label}
    </button>
  );
};
